<template>
  <div
    class="w-entry-unit-wrapper"
  >
    <WorkUnit
      :id='id'
      v-slot="{ readonly }"
      :class='[
        contentClass, {
          "w-entry-unit": true,
          "action-absolute-pos": actionAbsolutePosition,
          "w-entry-unit__has-errors": hasErrors,
        }]'
      no-header
      :title="title"
      :toggle-content-visibility-on-mobile="toggleContentVisibilityOnMobile"
      :initial-show-content-on-xs="initialShowContentOnXs"
    >
      <template>
        <w-row
          no-gutters
          class='w-entry-unit__prepend-actions'
        >
          <slot
            name='prepend-actions'
            v-bind='{ readonly }'
          />
        </w-row>
        <w-row
          no-gutters
          class='w-entry-unit__actions justify-end'
        >
          <slot
            name='actions'
            v-bind='{ readonly }'
          />
        </w-row>
        <v-container
          :class='{ "w-entry-unit__content": true, "readOnly": readonly }'
          fluid
        >
          <slot
            name='default'
            v-bind='{ readonly }'
          />
        </v-container>
      </template>
    </WorkUnit>

    <label
      v-if='hasErrors'
      class='v-messages error--text pl-3'
    >
      {{ errors.join(',') }}
    </label>
  </div>
</template>

<script>
import WorkUnit from '@/components/global_components/unit/WorkUnit';

/**
 * @component WorkEntryUnit
 * @description Data entry unit card for forms. Shows a card with title,
 * optional actions and configurable mobile visibility.
 *
 * @prop {String} [id] - Unique ID of the unit.
 * @prop {Boolean} [actionAbsolutePosition=false] - Position actions absolutely.
 * @prop {Array} [errors=[]] - Error messages (turns border red).
 * @prop {String|Array|Object} [contentClass] - Additional CSS classes for the content.
 * @prop {String} [title] - Unit title.
 * @prop {Boolean} [toggleContentVisibilityOnMobile=true] - Allow collapsing content on mobile.
 * @prop {Boolean} [initialShowContentOnXs=false] - Show content on mobile initially.
 *
 * @slot default - Form fields and content.
 * @slot actions - Action buttons in the header.
 */
export default {
  name: 'WorkEntryUnit',
  components: { WorkUnit },
  props: {
    id: String,
    actionAbsolutePosition: { type: Boolean, default: false },
    errors: { type: Array, default: () => [] },
    contentClass: { type: [String, Array, Object], required: false },
    title: { type: String },
    toggleContentVisibilityOnMobile: { type: Boolean, default: true },
    initialShowContentOnXs: { type: Boolean, default: false}
  },
  computed: {
    hasErrors() {
      return this.errors.length > 0;
    }
  }
};
</script>

<style lang='scss'>
.w-entry-unit {
  margin-top: 1rem;
  position: relative;
  overflow: visible !important;

  &__has-errors {
    border-color: var(--v-error-base) !important;
  }

  .w-unit__content {
    padding: 0;
  }

  &__actions {
    width: 100%;
    right: 0;
  }

  &__prepend-actions {
    width: 100%;
    right: 0;
    top: -1.25rem;
    position: absolute;
  }
}

.w-entry-unit.action-absolute-pos {
  .w-entry-unit__actions {
    position: absolute;
  }
}
</style>
